import Header, {
  Actions,
  Content,
  Navigation,
  SubHeader,
  SubHeaderContent
} from './Header'

Header.Actions = Actions
Header.Content = Content
Header.Navigation = Navigation

SubHeader.Content = SubHeaderContent

export default Header

export { Actions, Content, Navigation, SubHeader, SubHeaderContent }
